export default {
  buttons: {
    change_plan: 'Vaihda hintasuunnitelmaa',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
  },
};
